import axios from 'axios';
import React from 'react';

import { HTMLContentReplacer } from '../../../../articleComponents/components/HTMLContentReplacer';
import { Layout } from '../../../../articleComponents/Layout';

import logger from 'lib/logger';
import { getEditorialContentPreview } from 'utils/Api/editorialContent';

const EXPECTED_PREVIEW_ERROR_STATUSES = [400, 403, 404];

export async function getServerSideProps({ params }) {
    try {
        const editorialContent = await getEditorialContentPreview(
            params.previewhash,
            params.url
        );

        if (!editorialContent || !editorialContent.title) {
            return { notFound: true };
        }

        return {
            props: {
                article: editorialContent,
                parsedContentBody: HTMLContentReplacer(
                    editorialContent?.contentBody
                ),
                hash: params.url,
                type: 'editorial-content',
            },
        };
    } catch (e) {
        const status = axios.isAxiosError(e) ? e.response?.status : undefined;
        if (!EXPECTED_PREVIEW_ERROR_STATUSES.includes(status)) {
            logger.error(
                { err: e, slug: params.url },
                'Failed to fetch article preview'
            );
        }
        return { notFound: true };
    }
}

const ArticleBody = ({
    article,
    hash,
    type,
    parsedContentBody,
    errorPage,
    urlRedirect,
    pageName,
}) => {
    const props = {
        article,
        hash,
        type,
        parsedContentBody,
        errorPage,
        urlRedirect,
        pageName,
    };
    return <Layout {...props} />;
};

export default ArticleBody;
